import MapboxDraw from '@mapbox/mapbox-gl-draw';

const DrawSimpleSelect = MapboxDraw.modes.simple_select;

export const SimpleSelect = {
  ...DrawSimpleSelect,

  // Override the click handler
  onClick(state, e) {
    const featureId = e.featureTarget?.properties?.id;
    const feature = featureId && this.getFeature(featureId);

    if (feature?.properties?.selectable === false) return;

    // fallback to normal select behavior - call the parent class method
    return DrawSimpleSelect.onClick.call(this, state, e);
  }
};
